import React, { useState, useEffect } from 'react';

interface StillnessFocusActivityProps {
  timeLeft: number;
  onInteraction: (data: any) => void;
}

export function StillnessFocusActivity({ timeLeft, onInteraction }: StillnessFocusActivityProps) {
  const [stillnessScore, setStillnessScore] = useState(100);
  const [lastMovement, setLastMovement] = useState(Date.now());

  useEffect(() => {
    const handleMouseMove = () => {
      const now = Date.now();
      if (now - lastMovement > 1000) {
        setStillnessScore(prev => Math.max(0, prev - 5));
        onInteraction({ type: 'movement_detected', timestamp: now });
      }
      setLastMovement(now);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [lastMovement, onInteraction]);

  return (
    <div className="text-center">
      <p className="text-lg font-semibold text-teal-700 mb-8 font-baloo">
        Be as still as a peaceful mountain! 🏔️
      </p>
      <div className="w-40 h-40 mx-auto mb-6 relative">
        <div className="w-full h-full rounded-full bg-gradient-to-br from-teal-200 to-green-300 flex items-center justify-center">
          <span className="text-4xl">🧘‍♀️</span>
        </div>
        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
          <div className="bg-white rounded-full px-4 py-2 shadow-lg">
            <span className="text-teal-700 font-bold font-baloo">
              Stillness: {stillnessScore}%
            </span>
          </div>
        </div>
      </div>
      <p className="text-teal-600 font-baloo">
        Stay calm and still. You're doing great! 🌟
      </p>
    </div>
  );
}
